/**
 * Display fallback for East Bay zips on quote.cabanapools.com.
 * The server zip lists in split_test_config.json decide which brand
 * receives the lead. This map only keeps the short form on screen when
 * assignment does not answer.
 */

const PLANS = [
  { key: 'chem', label: 'Weekly chemical service' },
  { key: 'chem_brush', label: 'Weekly chemical and brush service' },
  { key: 'full', label: 'Weekly full service' },
];

const BRANDS = {
  aqua: {
    experiment_id: 'direct_vs_cabana_aqua',
    brand_display_name: 'Aqua Pool Company',
    phone_e164: '+19259381441',
    phone_display: '(925) 938-1441',
    zips: [
      '94506', '94507', '94517', '94518', '94519', '94520', '94521', '94523',
      '94549', '94553', '94556', '94563', '94586', '94595', '94596', '94597',
      '94598',
    ],
  },
  hh: {
    experiment_id: 'direct_vs_cabana_hh',
    brand_display_name: 'H&H Pool Service',
    phone_e164: '+19258287665',
    phone_display: '(925) 828-7665',
    zips: [
      '94526', '94528', '94550', '94551', '94566', '94568', '94582', '94583',
      '94588',
    ],
  },
};

const ZIP_TO_BRAND = {};
for (const [brand, cfg] of Object.entries(BRANDS)) {
  for (const zip of cfg.zips) ZIP_TO_BRAND[zip] = brand;
}

export function eastBayZip(value) {
  const match = String(value || '').match(/\d{5}/);
  return match ? match[0] : '';
}

export function eastBayBrand(value) {
  return ZIP_TO_BRAND[eastBayZip(value)] || null;
}

export function eastBayFallbackAssignment(value) {
  const zip = eastBayZip(value);
  const brand = ZIP_TO_BRAND[zip];
  if (!brand) return null;
  const cfg = BRANDS[brand];
  return {
    in_test: true,
    arm: 'direct',
    experiment_id: cfg.experiment_id,
    brand,
    brand_display_name: cfg.brand_display_name,
    assignment_id: null,
    phone_display: cfg.phone_display,
    phone_e164: cfg.phone_e164,
    plans: PLANS.map(plan => ({ ...plan })),
    unconfirmed: true,
  };
}
